import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, FsCatalog } from '../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CongressContainerNarrowThreeColumnsConverter extends CmsConverterService<CongressContainerNarrowThreeColumnsData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      left: formData.st_left_content ?? defaultFSCatalog,
      right: formData.st_right_content ?? defaultFSCatalog,
      center: formData.st_center_content ?? defaultFSCatalog
    }
  }
}

export const CONGRESS_CONTAINER_NARROW_THREE_COLUMNS_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CongressContainerNarrowThreeColumnsData>>('CongressContainerNarrowThreeColumnsConverter')

export interface CongressContainerNarrowThreeColumnsData extends ConvertedComponentData {
  left: FsCatalog;
  center: FsCatalog;
  right: FsCatalog;
}
